import { createSelector } from '@ngrx/store';
import { getDragonflySharedState } from '../reducers';

export const getEliquaActiveComponentState = createSelector(
  getDragonflySharedState,
  (state) => state.eliqua,
);

export const getActiveComponent = createSelector(
  getEliquaActiveComponentState,
  ({ activeComponent }) => activeComponent,
);

export const getActiveTabIndex = createSelector(
  getEliquaActiveComponentState,
  ({ activeTabIndex }) => activeTabIndex,
);

export const getSubscriptionValidity = createSelector(
  getEliquaActiveComponentState,
  ({ isSubscriptionActive }) => isSubscriptionActive,
);

export const enableLockedOverlay = createSelector(
  getEliquaActiveComponentState,
  ({ enableLockedOverlay }) => enableLockedOverlay,
);

export const getSubscriptionEndDate = createSelector(
  getEliquaActiveComponentState,
  ({ subscriptionEndDate }) => subscriptionEndDate,
);

export const getRenderPaginator = createSelector(
  getEliquaActiveComponentState,
  ({ activeComponent }) =>
    activeComponent !== 'UserSecurityGroupsComponent' &&
    activeComponent !== 'UserPolicyDocumentsComponent' &&
    activeComponent !== 'MerchantSummaryComponent' &&
    activeComponent !== 'MerchantDetailsComponent' &&
    activeComponent !== 'RedeemRulesComponent',
);

export const getLanguage = createSelector(
  getEliquaActiveComponentState,
  ({ language }) => language,
);
